const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT;
const OKTA_DOMAIN = process.env.REACT_APP_OKTA_DOMAIN;

export const isAuthenticated = () => {
  const oktaToken = localStorage.getItem("okta-token-storage");
  if (oktaToken === "{}") {
    window.location = "/logout";
  }
  return !!oktaToken;
};

export const oktaConfig = {
  clientId: OKTA_CLIENT_ID,
  issuer: OKTA_DOMAIN,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email", "groups", "offline_access"],
  pkce: true,
  disableHttpsCheck: true,
  tokenManager: {
    syncStorage: false,
  },
};

export const isAdmin = () => {
  const oktaToken = localStorage.getItem("okta-token-storage");
  const { idToken } = JSON.parse(oktaToken);
  const isAdmin = idToken.claims?.groups?.includes("jarvis-admin") ?? false;
  return isAdmin;
};
